// 投资者互动
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
        <div
      style="background-color: #ffffff; height: 4rem;"
    ></div>
    <!-- 两行显示，，每一个有一段文字描述和一个视频，暂时图片代替 -->
    <div v-for="(list,i) in lists" class="list" v-if="i%2 == 0">
        <!-- 列的第一个 -->
        <div class="box1" @click="toShow(list.link)">
            <img class="img" :src="list.image">
            <div class="text">
                {{list.title}}
            </div>
        </div>
        <!-- 列的第二个 -->
        <div class="box2" v-if='i+1<lists.length' @click="toShow(lists[i+1].link)">
            <img class="img" :src="lists[i+1].image">
            <div class="text">
                {{lists[i+1].title}}
            </div>
        </div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Shares',
  data () {
    return {
      lists: [],
      image: '',
    }
  },
  components: {
    // Header,
    Tabbar,
    Logo,
  },
  created () {
    this.Relation()
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
  },
  methods: {
    toShow (link) {
      window.location.href = link
    },
    async Relation () {
      const { data: data } = await api.getRelation()
      this.lists = data.data.results
      console.log(this.lists)
    }
  },
}
</script>

<style scoped>
.box1 {
  margin-left: 1.5rem;
}
.box2 {
  margin-right: 1.5rem;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.text {
  margin-top: 1.5rem;
  height: 4.55rem;
  width: 21.25rem;
  font-size: 1.5rem;
  /* 超出部分隐藏 */
  overflow: hidden;
}
.img {
  width: 21.25rem;
  height: 13.125rem;
}
.list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3rem;
}
</style>